import React from 'react'

import HeadNext from 'next/head'

import { Container } from 'components/Grid'
import Typography from 'components/Typography'

import classes from './Error404.module.scss'

const Error404 = () => {
  return (
    <>
      <HeadNext>
        <title>Page Not Found | GetApp</title>
      </HeadNext>
      <Container fixedWidth className={classes.pageContentContainer}>
        <Typography variant="heading-xl">Oops! You&apos;ve reached a page that doesn&apos;t exist.</Typography>
        <br />
        <div className={classes.options}>
          <Typography variant="body-sm">Don&apos;t worry. Here’s what you can do:</Typography>
          <br />
          <ul className={classes.list}>
            <li className={classes.item}>
              <Typography variant="body-sm">Use the search bar above</Typography>
            </li>
            <li className={classes.item}>
              <Typography variant="body-sm">
                Go back to the&nbsp;<a href="https://www.getapp.com">homepage</a>
              </Typography>
            </li>
            <li className={classes.item}>
              <Typography variant="body-sm">
                <a href="https://www.getapp.com/browse/">Explore by Category </a>
              </Typography>
            </li>
            <li className={classes.item}>
              <Typography variant="body-sm">
                Visit our&nbsp;<a href="https://www.getapp.com/resources/">Resources</a>
              </Typography>
            </li>
          </ul>
        </div>
      </Container>
    </>
  )
}

export default Error404
